import * as z from "zod"

import { jsonDbAtom } from "@axtesys/react-tools"

export const lastServerInteractionState = jsonDbAtom({
  key: "lastServerInteraction",
  default: 0,
  schema: z.number(),
})
